module.exports = __webpack_public_path__ + "static/img/err-4.a4afe36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/err-4.png
// module id = K1nZ
// module chunks = 1